var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPinkJohkuLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 29,
    viewBox: "0 0 91 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0H3.35223V20.2496C3.35223 21.5935 3.06073 22.7388 2.52632 23.6704C2.02429 24.5255 1.18219 25.4265 0 26.4039L2.76923 29C4.04858 28.2059 5.08502 27.366 5.89474 26.4955C6.78543 25.4724 7.38461 24.327 7.7085 23.029C7.90283 22.1585 8 20.9521 8 19.4402V0Z",
    fill: "#FF64A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4998 0C23.8456 0 26.4512 1.06259 28.3631 3.17279C30.1208 5.16327 31.015 7.78231 30.9996 11.0299C30.9996 14.2327 30.0899 16.8218 28.2706 18.8122C26.3587 20.9374 23.7685 22 20.4844 22C17.2003 22 14.61 20.9524 12.729 18.8571C10.9097 16.8367 10 14.2327 10 11.0299C10 7.79728 10.8943 5.17823 12.6674 3.17279C14.5638 1.06259 17.1849 0 20.4998 0ZM20.4998 18.7823C22.5504 18.7823 24.1077 17.9592 25.1869 16.3279C26.1275 14.9361 26.59 13.1551 26.59 11.0299C26.59 8.8449 26.1275 7.04898 25.2024 5.65714C24.1385 4.04082 22.5504 3.21769 20.4844 3.21769C18.4183 3.21769 16.8457 4.02585 15.7664 5.65714C14.8722 7.06395 14.425 8.8449 14.425 11.0299C14.425 13.1701 14.8876 14.9361 15.8127 16.3279C16.9074 17.9592 18.4646 18.7823 20.4998 18.7823Z",
    fill: "#FF64A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 0H46.5303V9.11429H36.4697V0H32V22H36.4697V12.332H46.5303V22H51V0Z",
    fill: "#FF64A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8786 11.6655C62.4536 11.2019 61.9983 10.8878 61.5126 10.7233L71.5295 0H66.172L58.3558 8.52481V0H54V21.985H58.3558V12.7274H58.4165C58.8567 12.9966 59.3727 13.4602 59.9494 14.1482L66.6577 22H72L62.8786 11.6655Z",
    fill: "#FF64A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M91 0H86.5303V14.1525C86.5303 17.2376 84.8484 18.7951 81.5 18.7951C78.1516 18.7951 76.4697 17.2376 76.4697 14.1525V0H72V14.2723C72 16.8033 72.9033 18.7651 74.741 20.128C76.4385 21.386 78.6967 22 81.5 22C84.3344 22 86.577 21.386 88.259 20.128C90.0811 18.7951 91 16.8332 91 14.2723V0Z",
    fill: "#FF64A5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPinkJohkuLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pink-johku-logo.ff1d345d557efe186d15ba2c5aae1226.svg";